import { render, html } from "lit-html";
import { classMap } from "lit-html/directives/class-map.js";
import connect from "../../../shared/data-store/connect";
import { store, ACTION_SET_PAGE } from "./DataStore";
import {
	createGenerator,
	PARAMS_MOBILE,
	PARAMS_DESKTOP,
} from "./PaginationGenerator";
import { translate } from "../../../shared/l10n/translate";
import { isAtLeast, unwatch, watch } from "../../dom/screen";
import { track } from "../../tracker/EventTracker";
import { scrollToTop } from "../../dom/smoothScroll";

customElements.define(
	"esc-hotel-list-pagination",
	class extends connect(HTMLElement, store) {
		constructor() {
			super();
			this.page = 0;
			this.totalPages = 0;
		}

		connectedCallback() {
			super.connectedCallback();
			watch(this, () => this.render());
		}

		disconnectedCallback() {
			unwatch(this);
		}

		update(state, dataStore) {
			this.page = state.page;
			this.totalPages = dataStore.visiblePagesCount;
			this.render();
		}

		render() {
			if (this.totalPages <= 1) {
				this.style.setProperty("display", "none");
				return;
			}

			this.style.removeProperty("display");

			const generatorParams = isAtLeast("tablet")
				? PARAMS_DESKTOP
				: PARAMS_MOBILE;
			const generator = createGenerator(...generatorParams);

			render(
				html`
					<button
						class="hotel-list__pagination__button secondary-button ${classMap({
							hidden: this.page === 1,
						})}"
						@click=${this.onPreviousClick}
						aria-label=${translate("basic_previous")}
					>
						<span class="fa fa-angle-left"></span>
					</button>
					<div class="hotel-list__pagination__pages-wrapper">
						${generator(this.page, this.totalPages).map(page => {
							if (page.type === "ellipsis") {
								return html`<span class="hotel-list__pagination__ellipsis"
									>…</span
								>`;
							} else {
								const classes = classMap({
									"hotel-list__pagination__page": true,
									"hotel-list__pagination__page--active":
										page.page === this.page,
								});
								return html`
									<a
										class=${classes}
										href="#"
										@click=${this.onPageClick(page.page)}
									>
										${page.page}
									</a>
								`;
							}
						})}
					</div>
					<button
						class="hotel-list__pagination__button secondary-button ${classMap({
							hidden: this.page === this.totalPages,
						})}"
						@click=${this.onNextClick}
						aria-label=${translate("basic_next")}
					>
						<span class="fa fa-angle-right"></span>
					</button>
				`,
				this,
				{ host: this },
			);
		}

		go(page, source) {
			const lastPage = this.page;
			this.dispatchAction(ACTION_SET_PAGE, page);

			scrollToTop(document.getElementById("search-panel"));

			const sourceMap = {
				previous: "Zurück",
				next: "Weiter",
				page: page,
			};

			track(
				"Liste",
				`Blaettern | ${this.totalPages}`,
				`${lastPage} | ${sourceMap[source]}`,
			);
		}

		onPageClick(page) {
			return event => {
				event.preventDefault();
				if (this.page !== page) {
					this.go(page, "page");
				}
			};
		}

		onPreviousClick() {
			this.go(this.page - 1, "previous");
		}

		onNextClick() {
			this.go(this.page + 1, "next");
		}
	},
);
